import React, { useRef, useState } from 'react'
import SelectMineralTypes from '../../../core/components/UI/SelectMineralTypes'
import SelectMultiMinerals from '../../../core/components/UI/SelectMultiMinerals'
import { MdCheck, MdClose } from 'react-icons/md'
import DatePickerSingle from '../../../core/components/UI/DatePickerSingle'
import { FaSpinner } from 'react-icons/fa'
import SelectOpportunityStatusTypes from '../../../core/components/UI/SelectOpportunityStatusTypes'
import useOpportunitiesActions from '../../hooks/useOpportunitiesActions'
import { useNavigate, useParams } from 'react-router-dom'
import { toastSuccess } from '../../../helper'
import moment from 'moment'

export default function FormEditOpportunity({ opportunity }) {
  const { country_id, opportunity_id } = useParams()
  const navigate = useNavigate()
  const { updateCountryOpportunity, inProgress } = useOpportunitiesActions()

  const [opportunityMineralsType, setOppornitytMineralsType] = useState(
    opportunity?.category_id,
  )
  const [isExpired, setIsExpired] = useState(opportunity?.is_expired)
  const opportunityTitleArRef = useRef(null)
  const opportunityTitleEnRef = useRef(null)
  const [mineralsIds, setMineralsIds] = useState(opportunity?.minerals_ids)
  const rawMineralsArRef = useRef(null)
  const rawMineralsEnRef = useRef(null)
  const opportunityTypeArRef = useRef(null)
  const opportunityTypeEnRef = useRef(null)
  const [hasArea, setHasArea] = useState(opportunity?.area != null)
  const opportunityAreaRef = useRef(null)
  const [hasDate, setHasDate] = useState(opportunity?.started_at != null)
  const [opportunityDate, setOpportunityDate] = useState(
    opportunity?.started_at,
  )
  const opportunityLinkRef = useRef(null)

  const getMineralLabels = (minerals, key, separator) =>
    minerals
      .filter((m) => m[key])
      .map((m) => m[key])
      .join(separator)

  function handleOnChangeMinerals(options) {
    if (!options?.length) return

    const text_ar = getMineralLabels(options, 'label', ' و')
    const text_en = getMineralLabels(options, 'name_en', ', ')
    const ids = getMineralLabels(options, 'value', ',')

    setMineralsIds(ids.split(','))
    rawMineralsArRef.current.value = text_ar
    rawMineralsEnRef.current.value = text_en
  }

  async function handleOnSubmitCreateOpportunityForm(event) {
    event.preventDefault()
    let formattedDate = null
    if (hasDate && opportunityDate) {
      formattedDate = moment(opportunityDate).isValid()
        ? moment(opportunityDate).format('YYYY-MM-DD')
        : null
    }

    const payload = {
      category_id: opportunityMineralsType,
      title_ar: opportunityTitleArRef.current.value,
      title_en: opportunityTitleEnRef.current.value,
      minerals_ids: mineralsIds,
      raw_materials_ar: rawMineralsArRef.current.value,
      raw_materials_en: rawMineralsEnRef.current.value,
      type_ar: opportunityTypeArRef.current.value,
      type_en: opportunityTypeEnRef.current.value,
      area: hasArea ? opportunityAreaRef.current.value : null,
      started_at: formattedDate, // ✅ Now in 'YYYY-MM-DD'
      attachment_link: opportunityLinkRef.current.value,
      is_expired: isExpired,
    }

    const message = await updateCountryOpportunity(
      country_id,
      opportunity_id,
      payload,
    )
    if (message) {
      toastSuccess(message)
      navigate(`/countries/opportunities`)
    }
  }

  return (
    <form
      onSubmit={handleOnSubmitCreateOpportunityForm}
      className="flex flex-col gap-4"
    >
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTUNITY_TYPE"
          >
            صنف المعادن<span className="text-danger-600">*</span>
          </label>
          <SelectMineralTypes
            defaultValue={opportunity?.category_id}
            onChange={(value) => setOppornitytMineralsType(value)}
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTUNITY_IS_EXPIRED"
          >
            حالة الفرصة <span className="text-danger-600">*</span>
          </label>
          <SelectOpportunityStatusTypes
            onChange={(value) => setIsExpired(value)}
            defaultValue={opportunity?.is_expired}
          />
        </div>
      </div>
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTUNITY_TITLE_AR"
          >
            عنوان بالعربية <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_OPPORTUNITY_NAME_AR"
            ref={opportunityTitleArRef}
            type="text"
            defaultValue={opportunity?.title_ar}
            className="border-2 border-muted-500 px-4 py-2 leading-none outline-none"
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_OPPORTUNITY_TITLE_EN"
          >
            عنوان بالإنجليزية
          </label>
          <input
            id="ID_OPPORTUNITY_NAME_EN"
            ref={opportunityTitleEnRef}
            type="text"
            defaultValue={opportunity?.title_en}
            className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_OPPORTUNITY_RAW_MINERALS_ID"
          >
            الخامات <span className="text-danger-600">*</span>
          </label>
          <SelectMultiMinerals
            onChange={handleOnChangeMinerals}
            defaultValue={opportunity?.minerals?.map((mineral) => mineral.id)}
          />
        </div>
        <div className="flex gap-4">
          <input
            id="ID_OPPORTUNITY_RAW_MINERALS_AR"
            ref={rawMineralsArRef}
            type="text"
            defaultValue={opportunity?.raw_materials_ar}
            className="w-full border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
          <input
            dir="ltr"
            id="ID_OPPORTUNITY_RAW_MINERALS_EN"
            ref={rawMineralsEnRef}
            type="text"
            defaultValue={opportunity?.raw_materials_en}
            className="w-full border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
        </div>
      </div>
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTUNITY_TYPE_AR"
          >
            نوع بالعربية
            <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_OPPORTUNITY_TYPE_AR"
            ref={opportunityTypeArRef}
            type="text"
            defaultValue={opportunity?.type_ar}
            className="border-2 border-muted-500 px-4 py-2 leading-none outline-none"
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_OPPORTUNITY_TYPE_EN"
          >
            نوع بالإنجليزية
          </label>
          <input
            dir="ltr"
            id="ID_OPPORTUNITY_TYPE_EN"
            ref={opportunityTypeEnRef}
            type="text"
            defaultValue={opportunity?.type_en}
            className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
        </div>
      </div>
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTUNITY_AREA"
          >
            المساحة (كم<sup>2</sup>)
          </label>
          <div className="flex">
            <input
              disabled={!hasArea}
              id="ID_OPPORTUNITY_AREA"
              ref={opportunityAreaRef}
              type="number"
              inputMode="numeric"
              step="any"
              defaultValue={opportunity?.area}
              className="w-full border-2 border-l-0 border-muted-500 px-4 py-2 leading-none outline-none disabled:bg-muted-100"
            />
            <button
              type="button"
              onClick={() => setHasArea(!hasArea)}
              className={`flex border-2 ${!hasArea ? 'border-success-600 bg-success-500' : 'border-danger-600 bg-danger-500'} px-4 py-2 text-white`}
            >
              {!hasArea ? <MdCheck size={22} /> : <MdClose size={22} />}
            </button>
          </div>
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTUNITY_CREATE_AT"
          >
            تاريخ الفرصة
          </label>
          <div className="flex">
            {hasDate ? (
              <DatePickerSingle
                onChange={(date) => setOpportunityDate(date)}
                id="ID_OPPORTUNITY_CREATE_AT"
                defaultValue={moment(opportunity?.started_at).toDate()}
              />
            ) : (
              <div className="h-full w-full border-2 border-l-0 border-muted-500 bg-muted-100" />
            )}
            <button
              type="button"
              onClick={() => setHasDate(!hasDate)}
              className={`flex border-2 ${!hasDate ? 'border-success-600 bg-success-500' : 'border-danger-600 bg-danger-500'} px-4 py-2 text-white`}
            >
              {!hasDate ? <MdCheck size={22} /> : <MdClose size={22} />}
            </button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_OPPORTUNITY_LINK"
        >
          رابط معلومات إضافية
        </label>
        <input
          dir="ltr"
          id="ID_OPPORTUNITY_LINK"
          ref={opportunityLinkRef}
          type="url"
          defaultValue={opportunity?.attachment_link}
          placeholder="https://..."
          className="border-2 border-muted-500 px-4 py-2 leading-none outline-none"
        />
      </div>
      <button
        type="submit"
        disabled={inProgress}
        className="flex w-full items-center justify-center gap-2 border-2 border-primary-600 bg-primary-600 px-6 py-3 font-bold text-white outline-none hover:border-accent-600 hover:bg-accent-600 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
      >
        {inProgress ? (
          <>
            <FaSpinner
              size={16}
              className="animate-spin"
            />
            <span>جاري تعديل فرصة...</span>
          </>
        ) : (
          <span>تعديل فرصة</span>
        )}
      </button>
    </form>
  )
}
